import React from 'react';
import { Baby } from 'lucide-react';

export default function EmptyStudentsState() {
  return (
    <div className="empty-state">
      <Baby size={48} style={{ marginBottom: '1rem', opacity: 0.5 }} />
      <p>
        No student accounts created yet.<br />
        Click ["Add Child"] to get started!
      </p>
    </div>
  );
}